export const ja_wallet = {
  main: "クリエイターにも、ユーザーにもトークン報酬を",
  sub1: "Ubiqのクリエイターは、ハードルなしでView数に応じたトークン報酬を獲得することができます。",
  sub2: "同時に一般ユーザーでも、広告を見るだけで、広告閲覧に対するトークン報酬を獲得できます。",
  sub3: "貯まったトークンは自分のウォレットに保存され、Amazonギフト券と交換したり、自分の銀行口座に振り込んだり、クリエイターへのチッピングや有料コンテンツ購入に使うことができます（現在開発中）。"
}